import styled from 'styled-components';
import theme from 'styles/theme';

export const ModalContentContainer = styled.div`
  span.green {
    color: ${theme.colors.bgGreen};
  }

  .alert {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;
